/** Set by the Umami tracker script (see index.html) - absent if it's blocked (adblock) or not loaded yet (local dev without the umami container). */
declare global {
  interface Window {
    umami?: {
      track: (eventName: string, data?: Record<string, unknown>) => void
    }
  }
}

/** Fire-and-forget custom event for the self-hosted Umami analytics. No-ops silently if the tracker isn't present. */
export function track(eventName: string, data?: Record<string, unknown>): void {
  window.umami?.track(eventName, data)
}
